import React from 'react'
import { Chip } from 'vnetwork-ui'

export type Size = 'large' | 'medium' | 'small'
export declare type Color =
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'warning'
    | 'success'
interface CellStatusProps {
    label?: string
    color?: Color
    size?: Size
    className?: string
}

const CellStatus: React.FC<CellStatusProps> = ({
    label = 'unset',
    color = 'primary',
    size = 'small',
    className,
}) => {
    return (
        <Chip
            label={label}
            size={size}
            variant="contained"
            color={color}
            className={`px-5 ${className}`}
        />
    )
}

export default CellStatus
